import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Header } from '../components/layout/Header';
import { MapPanel } from '../components/scan/MapPanel';
import { AddressStart } from '../components/scan/AddressStart';
import { ScanProgress } from '../components/scan/ScanProgress';
import { ScanStepper } from '../components/scan/ScanStepper';
import { StepWoning } from '../components/scan/StepWoning';
import { StepVerbruik } from '../components/scan/StepVerbruik';
import { StepAdvies } from '../components/scan/StepAdvies';
import { StepContact } from '../components/scan/StepContact';
import { useHomeScan } from '../hooks/useHomeScan';
import type { ScanStep } from '../types/scan';
export function Scan() {
  const scan = useHomeScan();
  const [params] = useSearchParams();
  const contentRef = useRef<HTMLDivElement>(null);
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    window.scrollTo(0, 0);
    const postcode = params.get('postcode');
    const nr = params.get('nr');
    if (postcode && nr) scan.start({
      postcode,
      number: nr,
      addition: params.get('toev') ?? ''
    });else if (params.get('demo')) scan.start('demo');
  }, [params, scan]);
  const goTo = (s: ScanStep) => {
    scan.goTo(s);
    if (window.innerWidth < 1024) contentRef.current?.scrollIntoView({
      block: 'start'
    });else window.scrollTo({
      top: 0
    });
  };
  const house = scan.house;
  return <div className="min-h-screen w-full bg-canvas" data-id="element-795" data-mp="1vyhwmxtaq416">
      <Header data-id="element-796" data-mp="1vzt00witx9rr" />
      <main className="mx-auto max-w-[1440px] px-4 pb-20 pt-4 sm:px-6 lg:grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1.05fr)] lg:gap-10 lg:px-8 lg:pt-6" data-id="element-797" data-mp="29wy2kmjc3qi9">
        <section aria-label="Luchtfoto" className="h-[360px] sm:h-[460px] lg:sticky lg:top-[96px] lg:h-[calc(100vh-120px)]" data-id="element-798" data-mp="24wju53dtmejp">
          <MapPanel phase={scan.phase} house={house} onEdit={scan.reset} data-id="element-799" data-mp="3le7l96un2eii" />
        </section>

        <div ref={contentRef} className="scroll-mt-24 pt-8 lg:pt-0" data-id="element-800" data-mp="3gfe7refcqnic">
          {scan.phase === 'result' && <div className="mb-8" data-id="element-801" data-mp="3sfkti6bz7se4">
              <ScanStepper step={scan.step} maxStepIndex={scan.maxStepIndex} onSelect={goTo} data-id="element-802" data-mp="3set6hjwg32zg" />
            </div>}

          <AnimatePresence mode="wait" data-id="element-803" data-mp="19t79i1bkzwl">
            <motion.div key={scan.phase === 'result' ? scan.step : scan.phase} initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.2,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-804" data-mp="68crne09m3mu">
              {(scan.phase === 'idle' || scan.phase === 'error') && <AddressStart errorKind={scan.errorKind} onSubmit={q => scan.start(q)} onDemo={() => scan.start('demo')} data-id="element-805" data-mp="3emd1wenwawwf" />}
              {scan.phase === 'scanning' && <ScanProgress data-id="element-806" data-mp="2lyzdj4y9j9nx" />}
              {scan.phase === 'result' && house && <>
                  {scan.step === 'woning' && <StepWoning house={house} usage={scan.usage} onChange={scan.updateUsage} onNext={() => goTo('verbruik')} data-id="element-807" data-mp="2jet0m7ro88v8" />}
                  {scan.step === 'verbruik' && <StepVerbruik house={house} usage={scan.usage} onChange={scan.updateUsage} onBack={() => goTo('woning')} onNext={() => goTo('advies')} data-id="element-808" data-mp="29gmxjmu4owos" />}
                  {scan.step === 'advies' && <StepAdvies usage={scan.usage} advice={scan.advice} recommended={scan.recommended} onSelectProduct={scan.setProductId} onBack={() => goTo('verbruik')} onNext={() => goTo('contact')} data-id="element-809" data-mp="1vo70r3rtluwb" />}
                  {scan.step === 'contact' && <StepContact house={house} advice={scan.advice} onBack={() => goTo('advies')} data-id="element-810" data-mp="1ct07q7rk8ckb" />}
                </>}
            </motion.div>
          </AnimatePresence>
        </div>
      </main>
    </div>;
}